import axios from 'axios'
import { getAppHost, getAppEndpointVersion } from 'helpers'

// Get Available Models
const getAvailableModels = async (app, appSettings) => {
  if (!app || app.length === 0) return []
  try {
    const apiHost = getAppHost(appSettings)
    let baseURL = app.appRegion.meta.useSSL ? 'https://' : 'http://'
    baseURL = `${baseURL}${apiHost}/${getAppEndpointVersion(
      app,
    )}/ai-agents/agent-builder/agents/available-models`

    const response = await axios.get(baseURL, {
      headers: {
        appId: app.id,
        apiKey: app.accessKey,
        'Content-Type': 'application/json',
        Accept: 'application/json',
        chatapiversion: 'v3.0',
      },
    })

    return response.data
  } catch (error) {
    throw error
  }
}

export default getAvailableModels
